<template>
	<b-card class="sa-card" header="Prodotto" header-tag="header" footer-tag="footer" title="">
		<b-row>
			<b-col cols="9" xs="9" sm="9" md="9" lg="9" xl="9">
				<label class="sa-label-data">Nome:</label>
				<span>{{ jsonData.nome }}</span>
			</b-col>
			<b-col cols="3" xs="3" sm="3" md="3" lg="3" xl="3">
				<label class="sa-label-data">Tipo:</label>
				<span>{{ jsonData.tipo }}</span>
			</b-col>

			<b-col cols="6" xs="3" sm="3" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data Inizio:</label>
				<span>{{ formatDate(jsonData.dataOraInizio) }}</span>
			</b-col>
			<b-col cols="6" xs="3" sm="3" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data Fine:</label>
				<span>{{ formatDate(jsonData.dataOraFine) }}</span>
			</b-col>
			<b-col cols="6" xs="3" sm="3" md="3" lg="3" xl="3">
				<label class="sa-label-data">Stato Attuale:</label>
				<stati-colors :statoLabel="jsonData.statoAttuale"></stati-colors>
			</b-col>
			<b-col cols="6" xs="3" sm="3" md="3" lg="3" xl="3">
				<label class="sa-label-data">Stato Data/Ora:</label>
				<span>{{ formatDateTime(jsonData.statoAttualeDataOra) }}</span>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Descrizione:</label>
				<span>{{ jsonData.descrizione }}</span>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Note:</label>
				<span>{{ jsonData.note }}</span>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import StatiColors from "../utility/StatiColors.vue";

export default {
	mixins: [UtilityMixin],
	components: { StatiColors },
	data() {
		return {
			id: null,
			numeroTask: 0,
			numeroTaskCompleti: 0,
			pathResource: "/gestioneattivitaprogetti",
			jsonData: { nome: null, descrizione: "", stato: null },
		};
	},
	mounted() {
		this.id = this.$route.params.id;
		if (this.id !== "-1") {
			this.loadData();
		}
	},
	watch: {
		jsonData: {
			handler(jsonData) {
				this.$emit("updateJsonData", jsonData);
			},
			deep: true,
		},
	},
	methods: {
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.jsonData = response.data.data;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
	},
};
</script>

<style></style>
